
export enum IDCheckResult {
    Ok = 1,
    InvalidIDNumber = 2,
    IdAlreadyExists = 3,
}